import React from 'react';

import { Image } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { ResizeMode } from 'components/picture/types';
import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const UnreadSeparator = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.unreadSeparator, style] });

export const CenteredLine = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.centeredLine, style] });

export const UnreadSeparatorText = withTypography({ color: primitive.$blackOpacity50 });

export const StyledPicture = Image.withConfig({
  width: 'full',
  height: '186px',
  resizeMode: ResizeMode.contain,
  marginTop: '$12',
});

export const EmptyInboxTitle = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  mt: '$4',
  mb: '$4',
  color: primitive.$bbqBrown,
});

export const EmptyInboxCaption = withTypography({
  textAlign: 'center',
  color: primitive.$bbqBrown,
  style: { alignSelf: 'center', width: 270 },
});

const styles = StyleSheet.create({
  centeredLine: {
    borderColor: primitive.$blackOpacity50,
    borderTopWidth: 1,
    flexGrow: 1,
    marginHorizontal: spacing.$2,
  },
  unreadSeparator: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: spacing.$2,
    paddingVertical: spacing.$6,
  },
});
